<div class="relative flex flex-auto flex-col items-center gap-8">
  <div class="w-full max-w-3xl">
    <div class="surface-default w-full max-w-3xl rounded-xl border border-gray-5 p-4">
      <div class="flex flex-col">
        <!-- Header -->
        <div class="mb-4 flex w-full items-center">
          <!-- Left position header -->
          <div class="flex w-full items-center gap-4">
            <aura-avatar
              [srcImage]="$safeNavigationMigration(user().identity.avatar?.url)"
              [label]="user().identity.firstName"
              [size]="'2xl'"
            />
            <div class="flex flex-col gap-2">
              <div class="text-xl font-semibold">
                <span class="text-2xl font-semibold flex items-center gap-2 flex-wrap">
                  {{ user().identity.firstName | titlecase }}
                  {{ user().identity.lastName | titlecase }}
                  <aura-identity-status [status]="user().identity.verificationStatus" />
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="verificationStatusMenu"
                    matTooltip="Modifier le statut de vérification"
                    class="w-7! h-7! leading-7! text-neutral-11 hover:text-neutral-12"
                  >
                    <mat-icon class="text-sm! w-4! h-4!">edit</mat-icon>
                  </button>
                </span>
              </div>
              <div class="flex flex-col gap-1">
                <div class="flex items-center gap-1">
                  <mat-icon>email</mat-icon>
                  {{ user().contactInfos.email }}
                </div>
                <div class="flex items-center gap-1">
                  <mat-icon>phone</mat-icon>
                  {{ user().contactInfos.mobileNumber }}
                </div>
              </div>
            </div>
          </div>
          <!-- Left right header -->
          <div class="flex w-44 flex-col items-end">
            @if (user().state.status !== entityStatus.DELETED) {
              <button class="mb-2" mat-icon-button [matTooltip]="'Actions'" [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="impersonateUser()">Impersonner</button>
                <button mat-menu-item [matMenuTriggerFor]="entityStates">Status</button>
                <button mat-menu-item [matMenuTriggerFor]="verificationStatusMenu">
                  Vérification d'identité
                </button>
              </mat-menu>

              <mat-menu #entityStates="matMenu">
                @if (user().state.status === entityStatus.DEACTIVATED) {
                  <button mat-menu-item (click)="activateUser()">Activer</button>
                }
                @if (user().state.status !== entityStatus.DEACTIVATED) {
                  <button mat-menu-item (click)="openPatchStateDialog(entityStatus.DEACTIVATED)">
                    Désactiver
                  </button>
                }
                @if (user().state.status !== entityStatus.DELETED) {
                  <button mat-menu-item class="text-red" (click)="openPatchStateDialog(entityStatus.DELETED)">
                    Supprimer
                  </button>
                }
              </mat-menu>
            }

            <div class="flex flex-col items-end gap-1">
              <aura-state-status-chip [state]="user().state" />
            </div>
          </div>
        </div>

        <core-identity-review-banner [user]="user()" (userUpdated)="userUpdated.emit($event)" />
        <mat-divider></mat-divider>

        <mat-accordion multi>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="text-xl font-semibold">Informations personnelles</mat-panel-title>
            </mat-expansion-panel-header>
            <!-- Gender -->
            <div class="flex items-center gap-1">
              <mat-icon>
                @if (user().identity.gender === 'female') {
                  female
                } @else if (user().identity.gender === 'male') {
                  male
                } @else {
                  agender
                }
              </mat-icon>
              <div>
                {{ user().identity.gender! | genderDisplay | titlecase }}
              </div>
            </div>
            <!-- Birthday -->
            <div class="flex items-center gap-1">
              <mat-icon>cake</mat-icon>
              <div matTooltip="{{ age() }} ans" matTooltipPosition="right">
                {{ user().identity.birthDate! | luxonDate: 'dd LLL yyyy' }}
              </div>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="text-xl font-semibold">Paramètres</mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <div class="mb-1 font-semibold">Internationalisation</div>
              <div class="flex items-center gap-1">
                <mat-icon>schedule</mat-icon>
                {{ user().settings.internationalization.timezone }}
              </div>
              <div class="flex items-center gap-1">
                <mat-icon>language</mat-icon>
                {{ user().settings.internationalization.language }}
              </div>
              <div class="flex items-center gap-1">
                <mat-icon>currency_exchange</mat-icon>
                {{ user().settings.internationalization.currency }}
              </div>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="text-xl font-semibold">Roles</mat-panel-title>
            </mat-expansion-panel-header>
            <core-user-roles-edit
              [initialRoles]="user().roles"
              [closeEditing]="closeRolesEditing()"
              (saved)="saveRoles($event)"
            />
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="text-xl font-semibold">Abonnement actif</mat-panel-title>
            </mat-expansion-panel-header>
            @if (user().subscription; as sub) {
              <div class="flex flex-col gap-2">
                <div class="flex items-center gap-2">
                  <div class="font-semibold">Statut :</div>
                  <div
                    class="inline-flex items-center gap-x-1.5 rounded-md bg-neutral-a4 px-1.5 py-0.5 text-sm font-medium"
                  >
                    <div
                      class="size-1.5 rounded-full"
                      [class.bg-green-9]="sub.status === 'active' || sub.status === 'trialing'"
                      [class.bg-amber-9]="
                        sub.status === 'past_due' || sub.status === 'paused' || sub.status === 'incomplete'
                      "
                      [class.bg-red-9]="
                        sub.status === 'canceled' ||
                        sub.status === 'unpaid' ||
                        sub.status === 'incomplete_expired'
                      "
                    ></div>
                    {{ sub.status | titlecase }}
                  </div>
                </div>
                <div class="flex items-center gap-1">
                  <div class="font-semibold">ID :</div>
                  <aura-clipboard [textToCopy]="sub._id">{{ sub._id }}</aura-clipboard>
                </div>
                <div class="flex items-center gap-1">
                  <div class="font-semibold">Plan :</div>
                  <aura-clipboard [textToCopy]="$any(sub.plan)?.name || $any(sub.plan) || ''">{{
                    $any(sub.plan)?.name || $any(sub.plan)
                  }}</aura-clipboard>
                </div>
                <div class="flex items-center gap-1">
                  <div class="font-semibold">Période actuelle :</div>
                  <div>
                    Du {{ sub.currentPeriodStart | luxonDate: 'dd/LL/yyyy, HH:mm' }} au
                    {{ sub.currentPeriodEnd | luxonDate: 'dd/LL/yyyy, HH:mm' }}
                  </div>
                </div>
                <div class="flex items-center gap-1">
                  <div class="font-semibold">Annuler en fin de période :</div>
                  <div>{{ sub.cancelAtPeriodEnd ? 'Oui' : 'Non' }}</div>
                </div>
              </div>
            } @else {
              <div class="text-gray-9 text-sm italic">
                Aucune donnée d'abonnement trouvée pour cet utilisateur.
              </div>
            }
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="text-xl font-semibold"
                >Metadata
                <aura-clipboard class="text-md font-normal" [textToCopy]="user()._id">{{
                  user()._id
                }}</aura-clipboard></mat-panel-title
              >
            </mat-expansion-panel-header>
            <div class="flex flex-col gap-4">
              <div>
                <div class="mb-1 font-semibold">Authentification</div>
                <div class="flex flex-col gap-1">
                  <div class="flex items-center gap-1">
                    @if (user().metadata.credentials.keycloakUuid; as keycloakUuid) {
                      Keycloak UUID:<aura-clipboard [textToCopy]="keycloakUuid">{{
                        keycloakUuid
                      }}</aura-clipboard>
                    }
                  </div>
                  <div>
                    @if (user().metadata.credentials.lastUpdateAt) {
                      Dernière modification de mot de passe le
                      {{ user().metadata.credentials.lastUpdateAt! | luxonDate: 'dd/LL/yyyy, HH:mm' }}
                    } @else {
                      Le mot de passe n'a jamais été modifié.
                    }
                  </div>
                </div>
              </div>

              <div>
                <div class="mb-1 font-semibold">Stripe</div>
                <div class="flex flex-col gap-2">
                  @if (user().metadata.stripe?.customerId; as customerId) {
                    <div class="flex items-center gap-1">
                      Customer ID:<aura-clipboard [textToCopy]="customerId">{{ customerId }}</aura-clipboard>
                    </div>
                  }
                  @if (user().metadata.stripe?.verification; as verification) {
                    <div class="flex flex-col gap-1">
                      <div class="flex items-center gap-1.5 flex-wrap">
                        Dernier statut d'identité : {{ verification.status }}
                        <aura-identity-status [status]="verification.status" />
                        <button
                          mat-icon-button
                          [matMenuTriggerFor]="verificationStatusMenu"
                          matTooltip="Modifier le statut de vérification"
                          class="w-6! h-6! leading-6! text-neutral-11 hover:text-neutral-12"
                        >
                          <mat-icon class="text-xs! w-3.5! h-3.5!">edit</mat-icon>
                        </button>
                      </div>
                      @if (verification.sessions?.length) {
                        <mat-expansion-panel
                          togglePosition="before"
                          class="!border-0 w-full max-w-xl"
                          [expanded]="true"
                        >
                          <mat-expansion-panel-header class="!p-0">
                            <mat-panel-title class="!font-normal !text-md">
                              Sessions de vérification ({{ verification.sessions?.length }})
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="pt-3 flex flex-col gap-3">
                            <div
                              class="flex flex-col divide-y divide-neutral-a4 rounded-xl border border-neutral-a4 overflow-hidden bg-neutral-1"
                            >
                              @for (session of verification.sessions; track session.id) {
                                <div
                                  class="flex items-center justify-between p-3 gap-3 hover:bg-neutral-a3 transition-colors"
                                >
                                  <div class="flex items-center gap-2.5 min-w-0">
                                    <aura-identity-status [status]="session.status" />
                                    <div class="flex flex-col min-w-0">
                                      <div class="flex items-center gap-1.5 min-w-0">
                                        <a
                                          [routerLink]="['/stripe-verification-sessions', session.id]"
                                          class="font-mono text-xs font-semibold text-primary-11 hover:underline truncate"
                                        >
                                          {{ session.id }}
                                        </a>
                                        <aura-clipboard [textToCopy]="session.id" />
                                        @if (session.conciliation) {
                                          <span
                                            class="text-[10px] font-medium px-1.5 py-0.2 rounded-full border shrink-0"
                                            [class.bg-jade-3]="session.conciliation === 'success'"
                                            [class.text-jade-11]="session.conciliation === 'success'"
                                            [class.border-jade-6]="session.conciliation === 'success'"
                                            [class.bg-crimson-3]="session.conciliation === 'failed'"
                                            [class.text-crimson-11]="session.conciliation === 'failed'"
                                            [class.border-crimson-6]="session.conciliation === 'failed'"
                                            [class.bg-neutral-3]="session.conciliation === 'pending'"
                                            [class.text-neutral-11]="session.conciliation === 'pending'"
                                            [class.border-neutral-6]="session.conciliation === 'pending'"
                                          >
                                            {{
                                              session.conciliation === 'success'
                                                ? 'Concilié'
                                                : session.conciliation === 'failed'
                                                  ? 'Échec conciliation'
                                                  : 'En attente'
                                            }}
                                          </span>
                                        }
                                        @if (
                                          session.matchScore !== undefined && session.matchScore !== null
                                        ) {
                                          <span
                                            class="text-[10px] font-semibold px-1.5 py-0.2 rounded-full border shrink-0"
                                            [class.bg-jade-3]="session.matchScore >= 85"
                                            [class.text-jade-11]="session.matchScore >= 85"
                                            [class.border-jade-6]="session.matchScore >= 85"
                                            [class.bg-amber-3]="
                                              session.matchScore >= 70 && session.matchScore < 85
                                            "
                                            [class.text-amber-11]="
                                              session.matchScore >= 70 && session.matchScore < 85
                                            "
                                            [class.border-amber-6]="
                                              session.matchScore >= 70 && session.matchScore < 85
                                            "
                                            [class.bg-crimson-3]="session.matchScore < 70"
                                            [class.text-crimson-11]="session.matchScore < 70"
                                            [class.border-crimson-6]="session.matchScore < 70"
                                          >
                                            {{ session.matchScore }}%
                                          </span>
                                        }
                                      </div>
                                      <span class="text-xs text-neutral-11">
                                        {{ session.createdAt | luxonDate: 'dd/LL/yyyy, HH:mm' }}
                                      </span>
                                    </div>
                                  </div>
                                  <a
                                    [routerLink]="['/stripe-verification-sessions', session.id]"
                                    mat-icon-button
                                    class="text-neutral-11 hover:text-neutral-12 shrink-0"
                                    matTooltip="Accéder à la session de vérification"
                                  >
                                    <mat-icon class="text-base! w-4! h-4!">open_in_new</mat-icon>
                                  </a>
                                </div>
                              }
                            </div>
                            <mat-expansion-panel
                              class="!border-0 !shadow-none !bg-transparent"
                              [expanded]="false"
                            >
                              <mat-expansion-panel-header class="!p-0 !h-8 text-xs text-neutral-11">
                                <mat-panel-title class="!text-xs text-neutral-11"
                                  >Voir les données brutes (JSON)</mat-panel-title
                                >
                              </mat-expansion-panel-header>
                              <div class="pt-2">
                                <aura-code-block [code]="verification.sessions" />
                              </div>
                            </mat-expansion-panel>
                          </div>
                        </mat-expansion-panel>
                      }
                    </div>
                  } @else {
                    <div class="text-gray-9 text-sm italic">Aucune donnée de vérification Stripe.</div>
                  }
                </div>
              </div>
              <div>
                <div class="mb-1 font-semibold">Timestamp</div>
                <div class="flex flex-col">
                  <div class="flex items-center">
                    @if (user().metadata) {
                      Dernière connexion le
                      {{ user().metadata.lastLoginAt! | luxonDate: 'dd/LL/yyyy, HH:mm' }}
                    }
                  </div>
                  <div class="flex items-center">
                    Dernière modification le {{ user().updatedAt | luxonDate: 'dd/LL/yyyy, HH:mm' }}
                  </div>
                  <div class="flex items-center">
                    Inscrit le {{ user().createdAt | luxonDate: 'dd/LL/yyyy, HH:mm' }}
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>

<mat-menu #verificationStatusMenu="matMenu">
  <div class="px-3 py-1.5 text-xs font-semibold text-neutral-11 uppercase tracking-wider">
    Statut de vérification
  </div>
  <button
    mat-menu-item
    [disabled]="user().identity.verificationStatus === identityVerificationStatus.VERIFIED"
    (click)="updateVerificationStatus(identityVerificationStatus.VERIFIED)"
  >
    <mat-icon class="text-jade-9!">verified</mat-icon>
    <span>Vérifié (verified)</span>
  </button>
  <button
    mat-menu-item
    [disabled]="user().identity.verificationStatus === identityVerificationStatus.REVIEW_REQUIRED"
    (click)="updateVerificationStatus(identityVerificationStatus.REVIEW_REQUIRED)"
  >
    <mat-icon class="text-amber-9!">pending_actions</mat-icon>
    <span>Révision requise (review_required)</span>
  </button>
  <button
    mat-menu-item
    [disabled]="user().identity.verificationStatus === identityVerificationStatus.PROCESSING"
    (click)="updateVerificationStatus(identityVerificationStatus.PROCESSING)"
  >
    <mat-icon class="text-blue-9!">sync</mat-icon>
    <span>En cours (processing)</span>
  </button>
  <button
    mat-menu-item
    [disabled]="user().identity.verificationStatus === identityVerificationStatus.FAILED"
    (click)="updateVerificationStatus(identityVerificationStatus.FAILED)"
  >
    <mat-icon class="text-red-9!">cancel</mat-icon>
    <span>Échoué (failed)</span>
  </button>
  <button
    mat-menu-item
    [disabled]="user().identity.verificationStatus === identityVerificationStatus.UNVERIFIED"
    (click)="updateVerificationStatus(identityVerificationStatus.UNVERIFIED)"
  >
    <mat-icon class="text-neutral-9!">help_outline</mat-icon>
    <span>Non vérifié (unverified)</span>
  </button>
</mat-menu>
